jQuery(document).ready(function($) {

	$.misc = {
		init: function() {
			$('img').removeAttr('title');

			if (document.readyState == 'complete') {
				$.misc.languageSwitcher();
				$.misc.timeline();
				$.misc.initUrlParameter();
				$.misc.initFormPlaceholder();
				$.misc.tables();
			} else {
				// something was wrong with loading error, use window load event instead
				// 2022-03-03 workaround fix for category + description of a selected product
				// are not showing on live
				
				$(window).on('load', function(){
					$.misc.languageSwitcher();
					$.misc.timeline();
					$.misc.initUrlParameter();
					$.misc.initFormPlaceholder();
					$.misc.tables();
				});
				
			}
	
		},

		tables: function() {
			// 2022-03-02 Borlabs Cookie Plugin had a problem
			// the plugin uses tables and the cardtable class crashed the plugin
			if(!$('table').parent().hasClass('borlabs-hide')){
				$('table').cardtable({
					myClass: 'm-table__responsive' +
						''
				});
			}
		},

		timeline: function() {

			$('.m-timeline').on('click', '.m-timelineitem__year', function() {
				$(this).closest('.m-timelineitem').toggleClass('open');

				return false;
			});

			// $('.m-timelineitem').each($).wait(650, function() {
			// 	//$(this).addClass('open');
			// });
		},

		languageSwitcher: function() {

			$(document).on('click touchstart', '.m-language-switcher', function(e) {
				if (e.type === "touchstart") {
					e.stopPropagation();
					e.preventDefault();
				}

				var oLinks = $('.m-language-switcher__links');

				oLinks.toggleClass('active');
				oLinks.css('display', 'block');

				oLinks.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
					$('.m-search-form__input').focus();

					if (!oLinks.hasClass('active')) {
						oLinks.css('display', 'none')
					}
				});
			});

		},

		getUrlParameter: function(sParam) {
			var sPageURL = decodeURIComponent(window.location.search.substring(1)),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined ? true : sParameterName[1];
				}
			}
		},

		initUrlParameter: function() {
			$('input[name="category"]').each(function() {
				if ($(this).parents('.m-contact__trigger--ref').length === 0) {
					var sParam = decodeURIComponent($.misc.getUrlParameter('category'));
					if (sParam !== "" && sParam !== "undefined") {
						$(this).val(sParam);
						$(this).parents('.m-form__field--hidden').css('display', 'block');
					}
				}
			});

			$('input[name="description"]').each(function() {
				if ($(this).parents('.m-contact__trigger--ref').length === 0) {
					var sParam = decodeURIComponent($.misc.getUrlParameter('description'));
					if (sParam !== "" && sParam !== "undefined") {
						$(this).val(sParam);
						$(this).parents('.m-form__field--hidden').css('display', 'block');
					}
				}
			});
		},

		initFormPlaceholder: function() {
			$('input[placeholder]:not(.noconvert), textarea[placeholder]:not(.noconvert)').each(function() {
				var aClasses = ['m-placeholder'];
				if ($(this).val() !== "") {
					aClasses.push('m-placeholder__focused');
				}
				$(this).addClass('m-placeholder__existing');
				$(this).after('<div class="focus-border"></div><div class="' + aClasses.join(' ') + '">' + $(this).attr('placeholder') + '</div>');
				$(this).removeAttr('placeholder');
				$(this).parent().css('display', 'block');
			});

			$(document).on('focus', '.m-placeholder__existing', function() {
				$(this).siblings('.m-placeholder').addClass('m-placeholder__focused');
			}).on('blur', '.m-placeholder__existing', function() {
				if ($(this).val() === "") {
					$(this).siblings('.m-placeholder').removeClass('m-placeholder__focused');
				}
			});

			$(document).on('click', '.m-placeholder', function() {
				$(this).siblings('input').focus();
			});
		},
	}

});